import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    campaignDataList: [],
    pageCount: 0, 
    loaderForButton: false,  
    dataLoader: false, 
    size: 0, 
    total: 0, 
}

const campaignDetailSlice = createSlice({
    name: "campaignDetail",
    initialState,
    reducers: {
        setCampaignViewList(state, action) {
            state.campaignDataList = action.payload.pagination ? [...state.campaignDataList, ...action.payload.campaignDataList] : action.payload?.campaignDataList
            state.pageCount = action.payload.pageCount || 0
            state.loaderForButton = action.payload.loaderForButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.dataLoader = action.payload?.dataLoader||false
            state.size = action.payload?.size
            state.total = action.payload?.total
        },
        setCampaignLoaderForButton(state, action) {
            state.loaderForButton = action?.payload
        },
        setCampaignLoader(state,action){
            state.dataLoader = action?.payload
        },
        clearCampaignList(action, state) {
            return initialState
        },
        defaultState(state, action) {
            return initialState
        },
        setCampaignStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
    },
})

export const {setCampaignLoader, setCampaignLoaderForButton, setCampaignViewList, clearCampaignList} = campaignDetailSlice.actions

export const campaignDetailActions = campaignDetailSlice.actions;

export default campaignDetailSlice
